export const LateProductLayout = {
  component: 'ProductCardContainer',
  props:{
    selectors: ['ProductSelector'],
    components: {
      Alert:{
        component: 'LoanCardAlert',
        props:{
          selectors: ['ProductSelector', 'BankAccountSelector'],
          components:{
            Icon: {
              component: 'IconComponent'
            },
            Cta:{
              component: 'LoanCardAlertCta',
              props:{
                selectors: ['ProductSelector'],
                actions:{
                  cta: "MakePaymentAction"
                }
              }
            },
            BadBankAction:{
              component: 'LoanCardAlertBadBank',
              props:{
                selectors: ['ProductSelector'],
                actions:{
                  badBankAction: "UpdateBankAction"
                }
              }
            },
            PendingPayoff:{
              component: 'LoanCardAlertPendingPayoff'
            }
          }
        }
      },
      Summary:{
        component: 'LoanCardSummary',
        props:{
          selectors: ['ProductSelector']
        }
      },
      Details:{
        component: 'LoanCardDetails',
        props:{
          selectors: ['ProductSelector', 'ActionablePaymentSelector'],
          components: {
            ToolTip:{
              component: 'LoanToolTip',
              props: {}
            },
            PaymentInfo:{
              component: "LoanAutoPay",
              props:{
                selectors: ["ProductSelector"]
              }
            },
            NextPayment:{
              component: "LoanNextPayment",
              props:{
                selectors: ["ActionablePaymentSelector", "ProductSelector"],
                components:{
                  PaymentInfo:{
                    component: "LoanAutoPay",
                    props:{
                      selectors: ["ProductSelector"]
                    }
                  }
                }
              }
            },
            ViewProduct: {
              component: "ViewLoanCta"
            }
          }
        }
      }
    }
  }
}

export const CurrentProductLayout = {
  component: 'ProductCardContainer',
  props:{
    selectors: ['ProductSelector'],
    components: {
      Alert:{
        component: 'LoanCardAlert',
        props:{
          selectors: ['ProductSelector', 'BankAccountSelector'],
          components:{
            Icon: {
              component: 'IconComponent'
            },
            BadBankAction:{
              component: 'LoanCardAlertBadBank',
              props:{
                selectors: ['ProductSelector'],
                actions:{
                  badBankAction: "UpdateBankAction"
                }
              }
            },
            PendingPayoff: {
              component: 'LoanCardAlertPendingPayoff'
            }
          }
        }
      },
      Summary:{
        component: 'LoanCardSummary',
        props:{
          selectors: ['ProductSelector']
        }
      },
      Details:{
        component: 'LoanCardDetails',
        props:{
          selectors: ['ProductSelector', 'ActionablePaymentSelector'],
          components: {
            ToolTip:{
              component: 'LoanToolTip',
              props: {}
            },
            PaymentInfo:{
              component: "LoanAutoPay",
              props:{
                selectors: ["ProductSelector"]
              }
            },
            NextPayment:{
              component: "LoanNextPayment",
              props:{
                selectors: ["ActionablePaymentSelector", "ProductSelector"],
                components:{
                  PaymentInfo:{
                    component: "LoanAutoPay",
                    props:{
                      selectors: ["ProductSelector"]
                    }
                  }
                }
              }
            },
            ViewProduct: {
              component: "ViewLoanCta"
            }
          }
        }
      }
    }
  }
}

export const PaidOffProductLayout = {
  component: 'ProductCardContainer',
  props:{
    selectors: ['ProductSelector'],
    components: {
      Alert:{
        component: 'LoanCardAlert',
        props:{
          selectors: ['ProductSelector'],
          components: {
            PendingPayoff:{
              component: 'LoanCardAlertPendingPayoff'
            }
          }
        }
      },
      Summary: {
        component: 'LoanCardSummary',
        props:{
          selectors: ['ProductSelector']
        }
      },
      Details: {
        component: 'LoanCardDetails',
        props:{
          selectors: ['ProductSelector', 'ActionablePaymentSelector'],
          components: {
            ToolTip:{
              component: 'LoanToolTip',
              props: {}
            },
            ViewProduct: {
              component: "ViewLoanCta"
            }
          }
        }
      }
    }
  }
}

export const ChargedOffProductLayout = {
  component: 'ProductCardContainer',
  props:{
    selectors: ['ProductSelector'],
    components: {
      Summary:{
        component: 'LoanCardSummary',
        props:{
          selectors: ['ProductSelector']
        }
      },
      Details:{
        component: 'LoanCardDetails',
        props:{
          selectors: ['ProductSelector', 'ActionablePaymentSelector'],
          components: {
            ToolTip:{
              component: 'LoanToolTip',
              props: {}
            }
          }
        }
      }
    }
  }
}

export const SoldProductLayout = {
  component: 'ProductCardContainer',
  props:{
    selectors: ['ProductSelector'],
    components: {
      Alert:{
        component: 'LoanCardAlert',
        props:{
          selectors: ['ProductSelector']
        }
      },
      Summary:{
        component: 'LoanCardSummary',
        props:{
          selectors: ['ProductSelector']
        }
      },
      Details:{
        component: 'LoanCardDetails',
        props:{
          selectors: ['ProductSelector', 'ActionablePaymentSelector'],
          components: {
            ToolTip:{
              component: 'LoanToolTip',
              props: {}
            },
            ViewProduct: {
              component: "ViewLoanCta"
            }
          }
        }
      }
    }
  }
}

export const AppliedProductLayout = {
  component: 'ProductCardContainer',
  props:{
    selectors: ['ProductSelector'],
    components: {
      Summary:{
        component: 'LoanCardSummary',
        props:{
          selectors: ['ProductSelector']
        }
      },
      Details:{
        component: 'LoanCardDetails',
        props:{
          selectors: ['ProductSelector', 'ActionablePaymentSelector'],
          components: {
            NextPayment:{
              component: "LoanNextPayment",
              props:{
                selectors: ["ActionablePaymentSelector", "ProductSelector"],
                components:{
                  ToolTip:{
                    component: 'LoanToolTip',
                    props: {}
                  }
                }
              }
            },
            ViewProduct: {
              component: "ViewLoanCta"
            }
          }
        }
      }
    }
  }
}

export const TransferredProductLayout = {
  component: "ProductCardContainer",
  props:{
    selectors: ["ProductSelector"],
    components:{
      Summary:{
        component: 'LoanCardSummary',
        props:{
          selectors: ['ProductSelector']
        }
      },
      Details:{
        component: 'TransferredLoanCardDetails',
        props:{
          selectors: ['ProductSelector']
        }
      }
    }
  }
}

export const AvantProductLayout = {
  component: 'ProductCardContainer',
  props:{
    selectors: ['ProductSelector'],
    components: {
      Summary:{
        component: 'LoanCardSummary',
        props:{
          selectors: ['ProductSelector'],
        }
      },
      Details:{
        component: 'LoanCardDetails',
        props:{
          selectors: ['ProductSelector', 'ActionablePaymentSelector'],
          components: {
            ToolTip:{
              component: 'LoanToolTip',
              props: {}
            },
            NextPayment:{
              component: "LoanNextPayment",
              props:{
                selectors: ["ActionablePaymentSelector", "ProductSelector"],
                components:{
                  PaymentInfo:{
                    component: "LoanAutoPay",
                    props:{
                      selectors: ["ProductSelector"]
                    }
                  }
                }
              }
            },
            ViewProduct: {
              component: "ViewLoanCta"
            }
          }
        }
      }
    }
  }
}

export const AvantCreditCardAccountLayout = {
  component: 'ProductCardContainer',
  props:{
    selectors: ['ProductSelector'],
    components: {
      Summary:{
        component: 'CreditCardAccountCardSummary',
        props:{
          selectors: ['ProductSelector'],
        }
      },
      Details:{
        component: 'CreditCardAccountCardDetails',
        props:{
          selectors: [],
          components: {
            CreditCardAccountBalance:{
              component: "CreditCardAccountBalanceSummary",
              props:{
                selectors: ["ProductSelector"],
                components:{
                  PaymentInfo:{
                    component: "LoanAutoPay",
                    props:{
                      selectors: ["ProductSelector"]
                    }
                  }
                }
              }
            },
            ViewProduct: {
              component: "ViewCreditCardAccountCta",
              props:{
                selectors: ["ProductSelector"]
              }
            }
          }
        }
      }
    }
  }
}
